import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import moment from 'moment';

import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormComponent from '../FormComponent';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';

import TimeClockContainer from '../../containers/TimeClock/TimeClock';
import Note from '../Note';
import EnhancedTable from '../table/EnhancedTable';
import ShiftTable from '../../pages/TimeClock/ShiftTable';
import ErrorIcon from '@material-ui/icons/Error';
import { red } from '@material-ui/core/colors';

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 24,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		whatToExport: {
			fontSize: 18,
			marginTop: 10,
			marginBottom: 10,
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
			color: 'white',
			marginRight: 10,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isExporting: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		exportingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		pleaseSelect: {
			fontStyle: 'italic',
			color: '#777',
		},
		currentShiftContainer: {
			border: `1px solid #eee`,
			backgroundColor: '#fcfcfc',
			padding: `20px 20px`,
			margin: '20px 0px',
			borderRadius: 5,
		},
		currentShiftTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 17,
		},
		errorIcon: {
			color: '#F44336',
			marginRight: 10,
		},
		currentLabel: {
			color: '#666',
			marginLeft: 30,
			marginRight: 5,
		},
		currentValue: {
			fontWeight: 500,
		},
		miniErrorIcon: {
			width: 30,
			height: 30,
			color: red[400],
			marginLeft: 0,
			marginTop: 0,
			marginRight: 5,
			verticalAlign: 'middle',
		},
	};
}

class PaycomExportConfirmation extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isExporting: false,
			exportingSuccessful: false,
			clockInDate: moment().format('YYYY-MM-DD'),
			//- { [timeClockShiftId]: { include: bool, clockOutPunchType: 'OD' | 'OL' | undefined } }
			reviewDecisions: {},
			refreshId: 1,
			showIncludedShifts: false,
		};
	}

	//- Rows that need the manager's attention before exporting: a recent clock-out
	//- (lunch vs done for the day) and/or a shift the nightly audit hasn't passed yet
	isReviewRow = (row) => {
		return !!row.clockOutDateTime && (row.needsClockOutDecision || row.auditStatus === 'PENDING');
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { open, timeClockShiftRows } = this.props;
		const justOpened = open && !prevProps.open;
		const rowsChanged = open && prevProps.timeClockShiftRows !== timeClockShiftRows;
		if (!justOpened && !rowsChanged) {
			return;
		}

		const reviewDecisions = {};
		(timeClockShiftRows || []).forEach((row) => {
			if (!this.isReviewRow(row)) {
				return;
			}
			reviewDecisions[row.timeClockShiftId] = {
				include: true,
				clockOutPunchType: row.needsClockOutDecision ? 'OD' : undefined,
			};
		});

		this.setState((state) => ({
			reviewDecisions,
			refreshId: state.refreshId + 1,
			showIncludedShifts: justOpened ? false : state.showIncludedShifts,
		}));
	}

	setReviewDecision = (timeClockShiftId, changes) => {
		this.setState((state) => ({
			reviewDecisions: {
				...state.reviewDecisions,
				[timeClockShiftId]: { ...state.reviewDecisions[timeClockShiftId], ...changes },
			},
			refreshId: state.refreshId + 1,
		}));
	};

	handleExport = () => {
		const {
			timeClockShiftPaycomExport,
			showErrors,
			searchApiParams = {},
			afterExport = _.noop,
		} = this.props;

		const params = {};
		[
			'accessToken',
			'shiftForUserIds',
			'timeClockLocationIds',
			'companyName',
			'afterDateTime',
			'beforeDateTime',
		].forEach((key) => {
			if (searchApiParams[key]) {
				params[key] = searchApiParams[key];
			}
		});

		//- Review answers: unchecked rows are excluded (held for the next export);
		//- decided recent clock-outs are sent as done-for-the-day (OD) or lunch (OL)
		const excludeTimeClockShiftIds = [];
		const recentClockOutEndOfDayShiftIds = [];
		const recentClockOutLunchShiftIds = [];
		_.forEach(this.state.reviewDecisions, (decision, timeClockShiftId) => {
			const id = Number(timeClockShiftId);
			if (!decision.include) {
				return excludeTimeClockShiftIds.push(id);
			}
			if (decision.clockOutPunchType === 'OD') {
				recentClockOutEndOfDayShiftIds.push(id);
			}
			if (decision.clockOutPunchType === 'OL') {
				recentClockOutLunchShiftIds.push(id);
			}
		});
		if (!_.isEmpty(excludeTimeClockShiftIds)) {
			params.excludeTimeClockShiftIds = excludeTimeClockShiftIds;
		}
		if (!_.isEmpty(recentClockOutEndOfDayShiftIds)) {
			params.recentClockOutEndOfDayShiftIds = recentClockOutEndOfDayShiftIds;
		}
		if (!_.isEmpty(recentClockOutLunchShiftIds)) {
			params.recentClockOutLunchShiftIds = recentClockOutLunchShiftIds;
		}

		this.setState({ isExporting: true, exportingSuccessful: false });

		timeClockShiftPaycomExport({
			params,
			savingMessage: 'Exporting to Paycom...',
			savedMessage: 'Paycom export added to export list',
			callback: (err) => {
				this.setState({ isExporting: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}
				this.setState({ exportingSuccessful: true });
				afterExport();
			},
		});
	};

	handleClose = () => {
		this.setState({
			exportingSuccessful: false,
			isExporting: false,
		});
		this.props.onClose();
	};

	render() {
		const {
			open,
			classes,
			timeClockShiftRows,
			paycomExportMessages = [],
			searchApiParams = {},
			skipClockedInShifts,
		} = this.props;

		const { isExporting, exportingSuccessful, reviewDecisions } = this.state;

		if (!timeClockShiftRows) {
			return null;
		}

		let numberOfFlaggedShifts = 0;
		let numberOfClockedInShifts = 0;
		let numberOfHeldShifts = 0;
		let numberOfVouchedPendingShifts = 0;
		let numberOfMissingPaycomIdShifts = 0;

		timeClockShiftRows.forEach((timeClockShiftRow) => {
			const {
				auditStatus,
				clockOutDateTime,
				timeClockShiftId,
				isMissingPaycomId,
			} = timeClockShiftRow;

			if (!clockOutDateTime) {
				numberOfClockedInShifts++;
				return;
			}

			//- Unchecked review rows are not part of this export, so they don't block it
			const decision = reviewDecisions[timeClockShiftId];
			if (decision && !decision.include) {
				numberOfHeldShifts++;
				return;
			}

			if (isMissingPaycomId) {
				numberOfMissingPaycomIdShifts++;
				return;
			}

			if (auditStatus === 'ERROR' || auditStatus === 'WARNING') {
				numberOfFlaggedShifts++;
				return;
			}

			//- Including a PENDING shift means the manager vouches for it — it no
			//- longer blocks the export the way it did before the review flow
			if (decision && auditStatus === 'PENDING') {
				numberOfVouchedPendingShifts++;
			}
		});
		const totalResults = timeClockShiftRows ? timeClockShiftRows.length : 0;
		const numberOfExportableShifts = totalResults - numberOfClockedInShifts - numberOfHeldShifts;

		const canNotExport =
			numberOfFlaggedShifts ||
			numberOfMissingPaycomIdShifts ||
			(numberOfClockedInShifts && !skipClockedInShifts) ||
			numberOfExportableShifts === 0;

		const note = `
		Please make sure all shifts look accurate before exporting. After shifts are exported
		any changes can only be made by a Sphere Admin and all changes need to happen in Paycom and
		in Sphere.
		`;

		const { shiftForUserIds, afterDate, beforeDate } = searchApiParams;

		let whatToExport;
		if (_.isEmpty(shiftForUserIds) && !afterDate && !beforeDate) {
			whatToExport = 'Exporting all shifts not already exported';
		} else {
			whatToExport = (
				<div>
					<div>Exporting shifts for the following:</div>
					{!_.isEmpty(shiftForUserIds) && <div>Employees : {shiftForUserIds.length}</div>}
					{afterDate && <div>After : {moment(afterDate).format('M/D')}</div>}
					{beforeDate && <div>Before : {moment(beforeDate).format('M/D')}</div>}
				</div>
			);
		}

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							<strong>{numberOfExportableShifts}</strong> shifts to be exported
							{!!numberOfHeldShifts && (
								<span style={{ color: '#E65100', fontSize: '70%', marginLeft: 10 }}>
									(+{numberOfHeldShifts} held for next run)
								</span>
							)}
						</div>
						<div>
							<IconButton
								aria-label="close"
								className={classes.closeButton}
								onClick={this.handleClose}
							>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<div className={classes.whatToExport}>{whatToExport}</div>

					<form>
						<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
							{!canNotExport && (
								<Grid item md={12}>
									<Note label={note} />
								</Grid>
							)}

							{!!numberOfClockedInShifts && !skipClockedInShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export these shifts because you
												have {numberOfClockedInShifts} shifts still clocked in during this date
												range. Wait until those shifts have been completed, or check "Skip shifts
												still clocked in" on the search form to export without them.
												{this.renderClockedInShiftList()}
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfClockedInShifts && !!skipClockedInShifts && (
								<Grid item md={12}>
									<Note>
										<div>
											<strong>Heads up</strong> Skipping <strong>{numberOfClockedInShifts}</strong>{' '}
											shifts that are still clocked in. They stay unexported and will be included in
											a future export once the employee has clocked out.
											{this.renderClockedInShiftList()}
										</div>
									</Note>
								</Grid>
							)}

							{numberOfExportableShifts === 0 && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> There aren't any shifts to export.
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!_.isEmpty(paycomExportMessages) && (
								<Grid item md={12}>
									<Note>
										<div>
											<strong>Heads up</strong> (these do not block the export)
											{paycomExportMessages.map((message, index) => (
												<div key={index}>{message}</div>
											))}
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfFlaggedShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export these shifts because you
												have <strong>{numberOfFlaggedShifts}</strong> flagged as WARNING / ERROR and
												must be corrected and cleared before you can export
												<br />
												<br />
												<a href="/timeClock/shiftAudit">
													Click here to visit the Shift Audit and fix these.
												</a>
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfMissingPaycomIdShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export because{' '}
												<strong>{numberOfMissingPaycomIdShifts}</strong> shifts belong to employees
												that do not have a Paycom Import Code set. Set the Paycom Import Code on
												their user profile, then run the search again.
												{this.renderMissingPaycomIdShiftList()}
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfVouchedPendingShifts && (
								<Grid item md={12}>
									<Note>
										<div>
											<strong>Heads up</strong> You are including{' '}
											<strong>{numberOfVouchedPendingShifts}</strong> shifts that are still PENDING
											audit (the audit passes shifts the day after they happen). By exporting them
											you are vouching for their accuracy. Uncheck any shift in the review list to
											hold it for the next export instead.
										</div>
									</Note>
								</Grid>
							)}

							<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleExport}
									disabled={isExporting || exportingSuccessful || canNotExport}
								>
									Export to Paycom
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isExporting}
									style={{ transitionDelay: isExporting ? '0ms' : '0ms' }}
									mountOnEnter
									unmountOnExit
								>
									<div className={classes.isExporting}>
										<CircularProgress style={{ verticalAlign: 'middle' }} />
										<span style={{ paddingLeft: 10 }}>Exporting...</span>
									</div>
								</Zoom>

								<Zoom
									in={exportingSuccessful}
									style={{
										transitionDelay: exportingSuccessful ? '250ms' : '0ms',
									}}
								>
									<div className={classes.exportingSuccessful}>
										<div className={classes.greenCheckedIcon} />
										<span style={{ paddingLeft: 10 }}>Exported to Paycom successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>

						{this.renderReviewSection()}

						<hr style={{ marginTop: 20, magrinBottom: 20 }} />

						<Grid item md={12}>
							<div
								className={classes.dialogTitle}
								style={{ cursor: 'pointer' }}
								onClick={() =>
									this.setState({ showIncludedShifts: !this.state.showIncludedShifts })
								}
							>
								<div>
									Shifts included in export
									<span style={{ color: '#777', fontSize: '60%', marginLeft: 10 }}>
										{this.state.showIncludedShifts ? 'click to hide' : 'click to show'}
									</span>
								</div>
								<IconButton size="small" aria-label="toggle included shifts">
									{this.state.showIncludedShifts ? <ExpandLessIcon /> : <ExpandMoreIcon />}
								</IconButton>
							</div>
							{this.state.showIncludedShifts && this.renderResults()}
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}

	renderReviewSection = () => {
		const { timeClockShiftRows } = this.props;
		const { reviewDecisions, refreshId } = this.state;

		const reviewRows = (timeClockShiftRows || []).filter(this.isReviewRow);
		if (_.isEmpty(reviewRows)) {
			return null;
		}

		const columns = [
			{ label: 'Include', displayId: 'includeDisplay', noSort: true },
			{ label: 'Employee', sortId: 'userDisplay', displayId: 'userDisplay' },
			{
				label: 'Clock In',
				sortId: 'clockInDateTime',
				displayId: 'clockInDateTimeDisplay',
			},
			{
				label: 'Clock Out',
				sortId: 'clockOutDateTime',
				displayId: 'clockOutDateTimeDisplay',
			},
			{
				label: 'Duration',
				sortId: 'durationDiff',
				displayId: 'durationDisplay',
			},
			{ label: 'Audit', sortId: 'auditStatus', displayId: 'auditStatus' },
			{ label: 'Clock-Out Decision', displayId: 'decisionDisplay', noSort: true },
			{ label: 'Status', displayId: 'statusDisplay', noSort: true },
		];

		const rows = reviewRows.map((row) => {
			const { timeClockShiftId } = row;
			const decision = reviewDecisions[timeClockShiftId] || { include: true };

			const includeDisplay = (
				<Checkbox
					checked={!!decision.include}
					color="primary"
					onChange={(e) => this.setReviewDecision(timeClockShiftId, { include: e.target.checked })}
				/>
			);

			let decisionDisplay = '—';
			if (row.needsClockOutDecision) {
				decisionDisplay = (
					<RadioGroup
						row
						value={decision.clockOutPunchType || 'OD'}
						onChange={(e) =>
							this.setReviewDecision(timeClockShiftId, { clockOutPunchType: e.target.value })
						}
					>
						<FormControlLabel
							value="OL"
							control={<Radio size="small" color="primary" />}
							label="Lunch break"
							disabled={!decision.include}
						/>
						<FormControlLabel
							value="OD"
							control={<Radio size="small" color="primary" />}
							label="Done for the day"
							disabled={!decision.include}
						/>
					</RadioGroup>
				);
			}

			const statusDisplay = decision.include ? (
				<span style={{ color: '#2E7D32' }}>Will export</span>
			) : (
				<span style={{ color: '#E65100' }}>Held for next export</span>
			);

			return {
				...row,
				includeDisplay,
				decisionDisplay,
				statusDisplay,
			};
		});

		return (
			<Grid item md={12}>
				<div>
					<div className={this.props.classes.dialogTitle} style={{ marginTop: 20 }}>
						Review — decide or exclude before exporting
					</div>
					<div style={{ color: '#666', marginBottom: 10 }}>
						These shifts either just ended (is the employee at lunch or done for the day?) or are
						still waiting on the nightly audit. Everything checked here will be exported; unchecked
						shifts are held for the next export.
					</div>
					<EnhancedTable
						rows={rows}
						columns={columns}
						isDense={true}
						defaultOrderBy={'clockOutDateTime'}
						defaultOrder={'desc'}
						refreshId={refreshId}
					/>
				</div>
			</Grid>
		);
	};

	//- Shifts blocking the export because the employee has no Paycom Employee ID,
	//- grouped by employee. Held (unchecked) review rows are not part of the
	//- export, so they are left out just like in the blocking count.
	renderMissingPaycomIdShiftList = () => {
		const { timeClockShiftRows } = this.props;
		const { reviewDecisions } = this.state;

		const missingIdRows = (timeClockShiftRows || []).filter((row) => {
			if (!row.isMissingPaycomId || !row.clockOutDateTime) {
				return false;
			}
			const decision = reviewDecisions[row.timeClockShiftId];
			return !(decision && !decision.include);
		});
		if (_.isEmpty(missingIdRows)) {
			return null;
		}

		const rowsByUser = _.groupBy(missingIdRows, 'userDisplay');
		return (
			<div style={{ marginTop: 8 }}>
				{_.map(rowsByUser, (rows, userDisplay) => (
					<div key={userDisplay} style={{ marginBottom: 5 }}>
						<strong>{userDisplay}</strong>
						{rows.map((row) => (
							<div key={row.timeClockShiftId} style={{ marginLeft: 15 }}>
								{row.clockInDateTimeDisplay} — {row.clockOutDateTimeDisplay} ({row.durationDisplay})
							</div>
						))}
					</div>
				))}
			</div>
		);
	};

	renderClockedInShiftList = () => {
		const { timeClockShiftRows } = this.props;
		const clockedInRows = (timeClockShiftRows || []).filter((row) => !row.clockOutDateTime);
		if (_.isEmpty(clockedInRows)) {
			return null;
		}
		return (
			<div style={{ marginTop: 8 }}>
				{clockedInRows.map((row) => (
					<div key={row.timeClockShiftId}>
						<strong>{row.userDisplay}</strong> — clocked in {row.clockInDateTimeDisplay} (
						{row.durationDisplay})
					</div>
				))}
			</div>
		);
	};

	//- Same table as the Run Time Clock Shift Audit page (grouped by employee/day,
	//- audit flags with reasons, hoverable notes) plus the Paycom punch types
	renderResults = () => {
		const { timeClockShiftRows, paycomSearchResult, refreshSearch } = this.props;
		const nonReviewRows = (timeClockShiftRows || []).filter((row) => !this.isReviewRow(row));

		if (_.isEmpty(nonReviewRows)) {
			return (
				<div style={{ color: '#777', fontStyle: 'italic' }}>
					All shifts are in the review list above.
				</div>
			);
		}

		const reviewShiftIds = (timeClockShiftRows || [])
			.filter(this.isReviewRow)
			.map((row) => row.timeClockShiftId);

		return (
			<ShiftTable
				apiResults={paycomSearchResult}
				excludeShiftIds={reviewShiftIds}
				paycomPunchInfoByTimeClockShiftId={_.get(
					paycomSearchResult,
					'paycomPunchInfoByTimeClockShiftId',
					{}
				)}
				compactAuditFlags={true}
				onRefreshNeeded={refreshSearch}
			/>
		);
	};
}

PaycomExportConfirmation.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	timeClockShiftRows: PropTypes.array,
	paycomExportMessages: PropTypes.array,
	paycomSearchResult: PropTypes.object,
	searchApiParams: PropTypes.object,
	afterExport: PropTypes.func,
	refreshSearch: PropTypes.func,
	skipClockedInShifts: PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockContainer,
])(PaycomExportConfirmation);
